var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestServiceBase } from '@ane/core/lib/services/RestServiceBase';
import { parseError } from '@ane/core/lib/utils/ErrorUtils';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
class WPSResource extends RestServiceBase {
    constructor() {
        super(EnvironmentService.endpoints.wps, '', parseError);
    }
    getWorkspaceMetaData(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/proxy-metadata?api-version=1.0-preview.1`;
            const result = yield this._get(address);
            return result;
        });
    }
    updateWorkspaceProxyStatus(data) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${data.workspaceId}/proxy-config/proxy-enabled?api-version=1.0-preview.1`;
            const result = yield this._put(data, address);
            return result;
        });
    }
    getWorkspaceProxyStatus(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/proxy-config/proxy-enabled?api-version=1.0-preview.1`;
            const result = yield this._get(address);
            return result;
        });
    }
    getWorkspaceServicePrincipals(workspaceId, identityType) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/service-principal?identityType=${identityType}&api-version=1.0-preview.1`;
            const result = yield this._get(address);
            return result;
        });
    }
    getSecurityGroups(workspaceId, search) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/security-group?search=${search}&api-version=1.0-preview.1`;
            const result = yield this._get(address);
            return result;
        });
    }
    getUAAAccess(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/uaa-access?api-version=1.0-preview.1`;
            const result = yield this._get(address);
            return result;
        });
    }
    putWorkspaceServicePrincipals(workspaceId, servicePrincipalId, data, identityType) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/proxy-config/service-principal/${servicePrincipalId}?identityType=${identityType}&api-version=1.0-preview.1`;
            const result = yield this._put(data, address);
            return result;
        });
    }
    deleteWorkspaceServicePrincipal(workspaceId, servicePrincipalId, identityType) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/proxy-config/service-principal/${servicePrincipalId}?identityType=${identityType}&api-version=1.0-preview.1`;
            const result = yield this._delete(address);
            return result;
        });
    }
    putWorkspaceSecurityGroups(workspaceId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/proxy-config/security-group?api-version=1.0-preview.1`;
            const result = yield this._put(data, address);
            return result;
        });
    }
    deleteWorkspaceSecurityGroup(workspaceId, securityGroupId, experimentRole) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspace/${workspaceId}/proxy-config/security-group/${securityGroupId}/experiment-role/${experimentRole}?api-version=1.0-preview.1`;
            const result = yield this._delete(address);
            return result;
        });
    }
}
export default new WPSResource();

//# sourceMappingURL=WPS.resource.js.map
